import { cn } from '@/shadcn-ui/utils';
import { Link, LinkProps } from 'react-router';
import Spacer from './spacer';
import LinkWithInventoryFilters from './link-with-inventory-filters';
import { TailwindBreakpoints } from '../types/tailwind-breakpoints';
import ArrowWithTailLeft from '@/icons/arrow-with-tail-left';
import { colors } from '@/theme/colors';

interface BreadcrumbBackProps extends LinkProps {
  text?: string;
  hideSpacerForBreakpoints?: TailwindBreakpoints[];
  toInventory?: boolean;
}

export default function BreadcrumbBack({
  to,
  text,
  hideSpacerForBreakpoints,
  toInventory = false,
  className,
}: BreadcrumbBackProps) {
  return (
    <>
      {toInventory ? (
        <LinkWithInventoryFilters
          to={to}
          className={cn('body-strong flex gap-[8px]', className)}
        >
          <ArrowWithTailLeft
            className="h-[24px] w-[24px] flex-shrink-0"
            fill={colors.neutral1}
          />
          {text}
        </LinkWithInventoryFilters>
      ) : (
        <Link
          to={to}
          className={cn('body-strong flex gap-[8px]', className)}
          reloadDocument={true}
        >
          <ArrowWithTailLeft
            className="h-[24px] w-[24px] flex-shrink-0"
            fill={colors.neutral1}
          />
          {text}
        </Link>
      )}
      <Spacer variant="height24" hideForBreakpoints={hideSpacerForBreakpoints} />
    </>
  );
}
